import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=01f9f391&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=ts&"
export * from "./Dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=01f9f391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9f391",
  null
  
)

export default component.exports